import { render, staticRenderFns } from "./SubBiddersReadOnlyView.vue?vue&type=template&id=9150c38a&scoped=true&"
import script from "./SubBiddersReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./SubBiddersReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9150c38a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
